<template>
 <a href="#" @click.prevent="gaTrackLink('Dashboard', 'Click Webinar Lesson', data.name, url)"
  class="upcoming-post list-group-item list-group-item-action p-0 my-2
  border border-left-0 rounded-lg list-group-item d-flex" style="min-height: 80px"
  :style="{'--bgColor': '#3D5AFE'}">
    <div v-show="!loading" class="d-flex flex-column py-3 px-4">
      <h5 class="font-weight-normal title-font-size">{{ data.name }}</h5>
      <p class="text-muted mb-0 mt-auto">
        <small>{{ dateTransfer(data.webinar.opened_at.datetime,
          data.webinar.closed_at.datetime) }}</small>
      </p>
    </div>
    <a href="#"
      @click.stop="gaTrackLink('Dashboard', 'Click Webinar URL', data.name, data.webinar.url)"
      target="_blank" class="d-flex align-items-center justify-content-center
        ml-auto flex-shrink-0 text-decoration-none"
      :style="{'background-color': 'rgba(61, 90, 254, 0.12)'}" style="width: 96px;">
      <span class="material-icons text-muted"> launch</span>
    </a>
  </a>
</template>

<script>
export default {
  props: {
    url: String,
    data: Object,
    loading: Boolean,
  },
  data() {
    return {

    };
  },
  methods: {
    dateTransfer(open, end) {
      const openDate = open ? this.$moment(open).format('YYYY-MM-DD') : '';
      const openTime = open ? this.$moment(open).format('A hh:mm') : '';
      const endTime = end ? this.$moment(end).format('A hh:mm') : '';
      return `${openDate} ${openTime} - ${endTime}`;
    },
  },
};
</script>

<style scoped>
.upcoming-post {
  position: relative;
  overflow: hidden;
}
.upcoming-post::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
  background-color: var(--bgColor)
}
.title-font-size {
  font-size: 1.25rem;
}
@media (max-width: 768px) {
  .title-font-size {
    font-size: 1rem;
  }
}
</style>
